/**
 * Whether the visitor agreed to analytics, and remembering the answer.
 *
 * Stored in localStorage rather than a cookie: a cookie asking permission to
 * set cookies is the joke that writes itself, and this value never needs to
 * reach the server.
 */

const key = 'pecgoprof:analytics-consent'

export type Consent = 'granted' | 'denied'

/** The recorded choice, or null when nobody has been asked yet. */
export function readConsent(): Consent | null {
  try {
    const stored = localStorage.getItem(key)
    return stored === 'granted' || stored === 'denied' ? stored : null
  } catch {
    // Private browsing and locked-down profiles throw on access. Treating that
    // as "not asked" is wrong — the banner would return on every page — but
    // treating it as consent would be worse.
    return 'denied'
  }
}

export function writeConsent(consent: Consent): void {
  try {
    localStorage.setItem(key, consent)
  } catch {
    // Nothing to do: the choice holds for this page and is asked again later.
  }
}
